module.exports = __webpack_public_path__ + "static/media/ilustra_48px.5eb37e20.svg";